// @flow
import * as React from 'react';
import { EmptyCard } from 'components';

export const NoItemsMessage = () => (
  <EmptyCard
    title="No Content"
    message="This channel does not have any content"
  />
);

export const RequestErrorMessage = () => (
  <EmptyCard
    title="This channel couldn't load."
    message="An Error occurred while fetching content. If this error persists, contact PowerReviews Support."
  />
);



// WEBPACK FOOTER //
// ./src/containers/channels/EmptyChannelStates.js